/**
 * Types and constants for LookerReport component
 */

export interface LookerReportProps {
  reportUrl: string;
  onLoad?: () => void;
  style?: React.CSSProperties;
  bare?: boolean;
  floatingActions?: boolean;
  active?: boolean;
}

export interface ReportState {
  iframeSrc: string;
  reportLoaded: boolean;
  triedPdfFallback: boolean;
  iframeError: string | null;
}

export const TRUSTED_LOOKER_DOMAINS = [
  'https://lookerstudio.google.com/',
  'https://datastudio.google.com/',
  'https://docs.google.com/',
  'https://drive.google.com/',
] as const;

export const DEFAULT_DOC_SCALE = 1.2;

export const SANDBOX_PERMISSIONS =
  'allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox';

export const ERROR_MESSAGE =
  'Unable to load document — it may be private, not published, or blocked from embedding.';
